<template>
  <div class="home">
  	<!--页头-->
    <HeaderNav />
    <!--中间内容部分-->
    <section class="wrap-list">
    	<!--顶部走马灯-->
    	<section class="top-bac">
    		<el-carousel
					ref="carousel"
	      	:interval="3000"
					:autoplay="true"
					@change="showCarouselText"
	      	trigger="click">
	        <el-carousel-item v-for="(item, index) in topBacList" :key="index">
	          <img :src="item" alt="" width="100%" height="100%">
						<transition name="fade-top">
							<section class="banner-text" v-show="carouselShowTextIndex === 1" key="1">
								<div class="text-bac text-bac1">Outstanding CPA</div>
								<div class="text-bac text-bac1">Network.</div>
								<div class="line"></div>
							</section>
						</transition>
						<transition name="fade-top">
							<section class="banner-text" v-show="carouselShowTextIndex === 0" key="2">
								<div class="text-bac text-bac2">High Converting Traffic,</div>
								<div class="text-bac text-bac2">Quality Leads.</div>
								<div class="line"></div>
							</section>
						</transition>
	        </el-carousel-item>
	      </el-carousel>
    	</section>
    	<!--中间文字-->
    	<section class="market-one">
    		<section class="left-text">
    			<h3>Performance Marketing.</h3>
    			<div class="hengxian">
    				<span class="content"></span>
    			</div>
    			<div>
						<span class="right-animation fr">
							<img style="width:21.6875rem;height:18.9375rem;" src="../../static/images/oxblue.png" alt=""/>
						</span>
						<h5 class="text">
							Soy game focusing on digital performance marketing, which brand name is Taptap,established in 2017, based in Shenzhen China.
						Taptap works on CPI, CPA and CPM CPL models, helping you achieve your goals.
						We ensure that mobile performance campaigns are targeted and optimized towards user acquisition goals across all markets.
						We help our Clients set the best KPIs and continuously optimize throughout the process. Meanwhile, Taptap devotes to supply
						professional and superior traffic realization solution for traffic owner. By working with API/S2S integration, traffic owner
						can promote all kinds of fat profit offers supplied by Taptap. Through various of rich and interesting advertisement content,
						traffic owner can get considerable revenue and activate users of their products.
						</h5>

    			</div>
    			<div class="wrap-btn">
    				<a class="first-button small-font-home" target="_balnk"
							href="http://taptap.offerslook.com/index.php?r=advertiser%2Fsite%2Fsignup">
    					<span class="small-font">BECOME AN ADVERTISER</span>
    					<i class="iconfont icon-ren small-font"></i>
    				</a>
    				<a class="second-button small-font-home" target="_blank"
							href="http://taptap.offerslook.com/index.php?r=site%2Fsignup">
    					<span>BECOME AN AFFILIATE</span>
    					<i class="iconfont icon-renqun"></i>
    				</a>
    			</div>
    		</section>

    	</section>
    	<section class="market-two">
    		<section class="left-text" style="width:65%;">
					<img style="margin-top: -2.8125rem;" src="../../static/images/hand2-1.png" alt="" width="100%"/>
    		</section>
			<section class="right-text" style="width:35%;">
				<h2 style="margin-top: 2.8125rem;">Our</h2>
				<h2>Blog.</h2>
				<h3>Stay Informed!</h3>
				<div class="hengxian">
				<span class="content"></span>
			</div>
			</section>
    	</section>
    	<!--底部合作方自动切换-->
			<FriendLink />
    </section>
    <!--页脚-->
    <!-- <FooterBar /> -->
    <!--回到顶部按钮-->

  </div>
</template>
<script>
import HeaderNav from '@/components/Header'
import FriendLink from '@/components/FriendLink'

export default {
  components: {
    HeaderNav, FriendLink
  },
  data () {
    return {
      imgs: [
        './static/images/client-ze.png',
        './static/images/client-a4g.png',
        './static/images/client-evo.png',
        './static/images/client-apus.png',
        './static/images/client-flex.png',
        './static/images/client-wise.png',
        './static/images/client-qubiq.png',
        './static/images/client-gorilla.png',
        './static/images/client-mobista.png'
      ],
      topBacList: [
      	'./static/images/banner3.png',
      	'./static/images/banner2.jpg'
      ],
      carouselShowTextIndex: 0
    }
  },
  mounted () {
  },
  methods: {
    showCarouselText (i) {
      this.carouselShowTextIndex = i
    },
    changeHandle (i) {
      console.log(i, '=======')
    }
  }
}
</script>
<style lang="scss">
.home {
	position: relative;
  .wrap-list {
    overflow: hidden;
    // height: 2291px;
    // margin-top: -118px;
    .market-one {
    	// width: 1100px;
    	// height: 351px;
    	padding: 6.25rem 7.8125rem;
    	position: relative;
    	margin: 0 auto;
    	background: white;
    	.left-text {
    		// width: 750px;
    		// float: left;
    		h3 {
    			margin: 0;
			    color: #171717;
			    font-family: 'Raleway', sans-serif;
			    font-size: 2.5rem;
			    line-height: 2.5625rem;
			    font-style: normal;
			    font-weight: bold;
			    letter-spacing: 0px;
			    text-transform: none;
    		}
    		.hengxian {
    			.content {
    				width: 3.4375rem;
    				height: 0.1875rem;
    				margin-top: 2.75rem;
    				margin-bottom: 2.625rem;
    				background: blue;
    				display: inline-block;
    			}
    		}
    		h5 {
    			margin: 0;
    			color: #171717;
			    font-family: 'Raleway', sans-serif;
			    font-size: 1.4375rem;
			    line-height: 2.125rem;
			    font-style: normal;
			    font-weight: 100;
			    letter-spacing: 0px;
			    text-transform: none;
					text-align: justify;
					// word-break: break-all;
					word-wrap: break-word;
					-webkit-hyphens: manual;
					-ms-hyphens: manual;
					hyphens: manual;
			    // height: 170px;
    		}
    		a {
    			text-decoration: none;
				color: #f6f6f6;
				font-size: 0.875rem;
				line-height: 3.0625rem;
				width: 17rem;
				text-align: center;
				height: 3.0625rem;
				font-style: normal;
				font-weight: 800;
				background-color: #1c7ac5;
				border-radius: 3.125rem;
				-moz-border-radius: 3.125rem;
				-webkit-border-radius: 3.125rem;
				letter-spacing: 0px;
				text-transform: none;
				border-width: 0px;
				// padding-left: 1.875rem;
				// padding-right: 1.875rem;
				display: inline-block;
				overflow: hidden;
				white-space: pre;
				i {
					margin-left: 10px;
				}
				}
				.wrap-btn {
					margin-top: 4.375rem;
				}
    		.first-button {
					margin-right: 0.9375rem;
    		}
    	}
    }
    .market-two {
    	// width: 1100px;
    	// height: 515px;
    	padding: 0 7.8125rem;
    	position: relative;
    	margin: 0 auto;
    	.left-text {
    		float: left;
    	}
    	.right-text {
    		float: left;
    		h2 {
    			color: #1c7ac5;
			    font-family: 'Raleway', sans-serif;
			    font-size: 7.6875rem;
			    line-height: 7.6875rem;
			    font-style: normal;
			    font-weight: 900;
			    letter-spacing: 0px;
			    text-transform: none;
			    margin: 0;
    		}
    		h3 {
			    color: #171717;
			    font-family: 'Raleway', sans-serif;
			    font-size: 2.5rem;
			    line-height: 2.5625rem;
			    font-style: normal;
			    font-weight: 900;
			    letter-spacing: 0px;
			    text-transform: none;
			    margin-bottom: 0;
    		}
    		.hengxian {
    			.content {
    				margin-top: 2.8125rem;
				    margin-bottom: 1.5625rem;
				    background-color: #1c7ac5;
				    height: 0.5625rem;
				    width: 10.6875rem;
				    display: inline-block;
    			}
    		}
    	}
    }
    .top-bac {
			.el-carousel__container {
				height: 31.0625rem /* 497/16 */;
			}
	  	.text-bac {
	  		// position: relative;
		    z-index: 11;
		    color: #ffffff;
		    font-size: 5.625rem;
		    line-height: 6.25rem;
		    font-family: 'Raleway';
		    font-style: normal;
		    font-weight: 900;
		    text-shadow: none;
		    letter-spacing: 0px;
		    text-transform: none;
	  	}
			.banner-text {
				position: absolute;
				top: 50%;
				left: 5%;
				transform: translateY(-50%);
				.line {
					width: 10%;
					height: 0.3125rem;
					background: #1c7ac5;
					margin-top: 3.125rem;
				}
			}
			.fade-top-enter-active {
				transition: all .8s;
				opacity: .8;
				transform: translateY(-50%);
			}
			.fade-top-enter {
				opacity: 0;
				transform: translateY(10%);
			}
	  }
	  .list {
	    background: #1c7ac5;
	    position: absolute;
	    bottom: 24.25rem;
	    width: 100%;
	   .link-img {
	   	width: 16.6875rem;
	   	height: 6.3125rem;
	   	padding: 2.5rem 0;
	   }
	  }
  }
}

@media screen and (max-width: 760px) {
	.home {
		.wrap-list {
			.left-text {
				h5 {
					text-align: left !important;
				}
			}
			.market-one {
				padding: 3rem 2rem;
			}
			.market-two {
				padding: 0 2rem;
				.left-text, .right-text {
					margin-right: 0;
					width: 100% !important;
					float: none;
					h2 {
						font-size: 3.8rem;
						line-height: 3.8rem;
					}
				}
			}
			.top-bac {
				.text-bac {
					font-size: 2.8rem;
					line-height: 3.1rem;
				}
				.el-carousel__container {
					height: 300px;
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue